import carousel from '../../../js/util/symbols/carousel'

export default {
  inject: { carousel },
  props: {
    direction: {
      type: String,
      required: true,
      validator: direction => [
        'next',
        'previous',
      ].includes(direction),
    },
  },
  methods: {
    setsCarouselDirection(direction) {
      this.carousel.$emit('carousel:direction', direction)
    },
    handleKeyUpevent(event) {
      this.carousel.$el.setAttribute('aria-live', true)
      const { direction } = this
      const eventToEmit = {
        ArrowLeft: direction,
        ArrowRight: direction,
      }[event.key]

      if (!eventToEmit) {
        return
      }


      event.preventDefault()
      this.setsCarouselDirection(eventToEmit)
    },

    removeLive() {
      this.carousel.$el.removeAttribute('aria-live')
    },
  },
  render(createElement) {
    const elementData = {
      on: {
        keyup: this.handleKeyUpevent,
        blur: this.removeLive,
        click: () => this.setsCarouselDirection(this.direction),
      },
    }

    return createElement('button', elementData, this.$slots.default)
  },
}

